import { Button, Card, message, Popconfirm, Select, Space, Table, Typography } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "@/server";
import { selectFilterOption } from "@/extensions/helper";
import { dictsGetUsers } from "@/extensions/dicts";
import { isMobile } from "@/extensions/design";
import "../users/user.css";

const { Text } = Typography;

const ProductExecutors = ({ productId }) => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const getData = () => {
    if (!productId) return;
    setLoading(true);
    serverFetch(`User/ProductUsers/${productId}`)
      .then(data => {
        setItems(data);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(getData, [productId]);

  useEffect(() => {
    setUsersLoading(true);
    dictsGetUsers(setUsers);
    setUsersLoading(false);
  }, []);

  const onAdd = () => {
    if (!selectedUserId) {
      message.warning("Выберите исполнителя");
      return;
    }
    setLoading(true);
    serverFetch("User/ProductAdd", {
      method: "POST",
      bodyData: { userId: selectedUserId, productId: productId }
    })
      .then(() => {
        setSelectedUserId(null);
        getData();
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  const onDelete = (userProductId) => {
    setLoading(true);
    serverFetch(`User/ProductDelete/${userProductId}`, { method: "DELETE" })
      .then(() => {
        setItems(prev => prev.filter(item => item.id !== userProductId));
        getData();
      })
      .catch(e => {
        message.error(e.userMessage);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const columns = [
    { title: "ФИО", dataIndex: "userName" },
    {
      title: "Действие",
      key: "action",
      width: 100,
      render: (_, record) => (
        <Popconfirm
          title="Убрать исполнителя?"
          description="Это действие нельзя отменить."
          onConfirm={() => onDelete(record.id)}
          okText="Да"
          cancelText="Нет"
        >
          <Button size="small" danger>Удалить</Button>
        </Popconfirm>
      ),
    },
  ];

  return !isMobile ? (
    <div className="sport-section">
      <Space style={{ marginBottom: 16 }}>
        <Select
          style={{ width: 300 }}
          placeholder="Выберите исполнителя"
          options={users}
          loading={usersLoading}
          showSearch
          filterOption={selectFilterOption}
          value={selectedUserId}
          onChange={setSelectedUserId}
          allowClear
        />
        <Button onClick={onAdd} loading={loading} disabled={!selectedUserId}>
          Добавить
        </Button>
      </Space>
      <Table
        columns={columns}
        size="small"
        dataSource={items}
        loading={loading}
        pagination={false}
        rowKey="id"
      />
    </div>
  ) : (
    <div className="product-mobile-container">
      <div className="product-mobile-actions" style={{ display: "flex", gap: 8 }}>
        <Select
          style={{ flex: 1 }}
          placeholder="Выберите исполнителя"
          options={users}
          loading={usersLoading}
          showSearch
          filterOption={selectFilterOption}
          value={selectedUserId}
          onChange={setSelectedUserId}
          allowClear
        />
        <Button onClick={onAdd} loading={loading} disabled={!selectedUserId}>
          Добавить
        </Button>
      </div>
      <div className="product-mobile-scroll">
        {items.map(item => (
          <Card key={item.id} className="product-packet-card-mobile" style={{ borderLeft: "4px solid #1677ff" }}>
            <div className="product-packet-card-row1-mobile">
              <Text strong>{item.name}</Text>
              <Popconfirm
                title="Убрать исполнителя?"
                description="Это действие нельзя отменить."
                onConfirm={() => onDelete(item.id)}
                okText="Да"
                cancelText="Нет"
              >
                <Button size="small" danger>Удалить</Button>
              </Popconfirm>
            </div>
          </Card>
        ))}
        {items.length === 0 && !loading && <div className="product-packet-empty-mobile">Нет данных</div>}
      </div>
    </div>
  );
};

export default ProductExecutors;
